import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const CallToActionLFC = lazy(() => import('.'));

class CallToActionLFCComponent extends ReactWebComponent {
    render() {
        return (
            <RootProviders>
                <CallToActionLFC />
            </RootProviders>
        );
    }
}

customElements.define('editor-call-to-action-banner-lfc', CallToActionLFCComponent);
